import { Star } from "lucide-react";

import type { VendorBasicInfo } from "@/types/product-request";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

interface VendorProfileProps {
	vendor: VendorBasicInfo;
	onMessageClick?: () => void;
	isLoading?: boolean;
	compact?: boolean;
	minimal?: boolean;
	selected?: boolean;
}

export function VendorProfile({ vendor, onMessageClick, minimal = false, compact = false, selected = false }: VendorProfileProps) {
	if (!vendor)
		return <div>Vendor not found</div>;

	if (minimal) {
		return (
			<div className="flex items-center gap-3">
				<div className="relative">
					<Avatar>
						<AvatarImage src="/placeholder.svg" alt={vendor.fullName} />
						<AvatarFallback>
							{vendor.fullName.charAt(0)}
						</AvatarFallback>
					</Avatar>

					<Badge className="absolute -top-1 -right-1 bg-blue-500">
						<span className="sr-only">Verified</span>
						✓
					</Badge>
				</div>
				<div>
					<h2 className="font-medium flex items-center gap-2">
						{vendor.fullName}
						<Badge variant="secondary" className="h-5">Verified</Badge>
					</h2>
					<div className="flex items-center gap-1 text-muted-foreground text-sm">
						<Star className="size-3 fill-yellow-400 stroke-yellow-400" />
						<span>{vendor.averageRating ?? "N/A"}</span>
					</div>
				</div>
			</div>
		);
	}

	if (compact) {
		return (
			<button
				onClick={onMessageClick}
				className={cn(
					"w-full p-3 rounded-lg hover:bg-accent transition-colors",
					selected && "bg-accent"
				)}
			>
				<div className="flex items-center gap-3">
					<div className="relative">
						<Avatar>
							<AvatarImage src="/placeholder.svg" alt={vendor.fullName} />
							<AvatarFallback>{vendor.fullName.charAt(0)}</AvatarFallback>
						</Avatar>
						<Badge className="absolute -top-1 -right-1 bg-blue-500">
							<span className="sr-only">Verified</span>
							✓
						</Badge>
					</div>
					<div className="flex-1 text-left">
						<h2 className="font-medium flex items-center gap-2">
							{vendor.fullName}
							<Badge variant="secondary" className="h-5">Verified</Badge>
						</h2>
						<div className="flex items-center gap-3 text-muted-foreground text-sm">
							<div className="flex items-center gap-1">
								<Star className="size-3 fill-yellow-400 stroke-yellow-400" />
								<span>{vendor.averageRating ?? "N/A"}</span>
							</div>
						</div>
					</div>
				</div>
			</button>
		);
	}

	return null;
}
